
import { useSelector } from "react-redux";
import Header from "../components/Header/Header";
import AddTeam from "../components/Teams/AddTeam";
import DisplayTeam from "../components/Teams/DisplayTeam";
import { useGetTeamsQuery } from "../features/teams/teamsApi";
export default function Teams() {
    // const { teams } = useSelector((state) => state.teams) || {};
   

    const auth = useSelector((state) => state.auth);
    const userEmail = auth.user.email;
    const {data: teams, isLoading} = useGetTeamsQuery(userEmail);

    let content = null;

    if(!isLoading && teams?.length > 0) {
        content = teams.map((team) => {
        //   console.log(team);
        
          return (
            <DisplayTeam key={team.id} team={team}
    />
        );

        })
    }else if(!isLoading && teams?.length === 0){
        content=<div>No Teams available</div>
    }else{
        content=<div>Error</div>
    }

    
    // content to display

    return (
        <div
        className="flex flex-col w-screen h-screen overflow-auto text-gray-700 bg-gradient-to-tr from-blue-200 via-indigo-200 to-pink-200"
    >
        <Header />
        <div className="px-10 mt-6 flex justify-between">
            <h1 className="text-2xl font-bold">Teams</h1>
            <AddTeam /> 
        </div>
        <div
            className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-10 mt-4 gap-6 overflow-auto"
        >
          
            {content}
        </div>
    </div>
    );
}